import { motion } from "framer-motion";
import { TrendingUp, Gamepad2, GraduationCap } from "lucide-react";

const useCases = [
  {
    icon: TrendingUp,
    title: "Analysts & Traders",
    description: "SEBI Compliant. Automated KYC. Manage paid research channels effortlessly.",
  },
  {
    icon: Gamepad2,
    title: "Gaming Communities",
    description: "Sync Discord roles and Slack memberships instantly. Tiered access for premium members.",
  },
  {
    icon: GraduationCap,
    title: "Educators & Coaches",
    description: "Deliver exclusive content. Handle enrollments and expiries automatically.",
  },
];

export default function LandingUseCases() {
  return (
    <section className="relative py-24 bg-dark-primary border-t border-dark-border/30">
        {/* Removed Testimonials as requested */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
            
            <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className="sticky top-24"
            >
                <h2 className="text-4xl md:text-6xl font-extrabold font-outfit text-text-primary uppercase tracking-tight mb-6">
                  Built for <br/><span className="text-golden-accent">Every Creator</span>
                </h2>
                <p className="text-xl text-text-secondary font-light max-w-md">
                    Whether you run a channel, server, or course, SuBs adapts to your workflow.
                </p>
            </motion.div>

            <div className="space-y-12">
                {useCases.map((uc, i) => (
                    <motion.div
                        key={uc.title}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: i * 0.1 }}
                        className="flex gap-6 group"
                    >
                        <div className="shrink-0 mt-1">
                            <div className="w-12 h-12 rounded-full bg-dark-secondary flex items-center justify-center border border-dark-border group-hover:border-golden-accent transition-colors">
                                <uc.icon size={24} className="text-text-primary group-hover:text-golden-accent transition-colors" strokeWidth={1.5} />
                            </div>
                        </div>
                        <div>
                            <h3 className="text-2xl font-bold font-outfit text-text-primary mb-2 group-hover:text-golden-accent transition-colors">
                                {uc.title}
                            </h3>
                            <p className="text-lg text-text-secondary font-light">
                                {uc.description}
                            </p>
                        </div>
                    </motion.div>
                ))}
            </div>

        </div>
      </div>
    </section>
  );
}
